/**
 * Do not edit directly, this file was auto-generated.
 */

module.exports = {
  "wb": {
    "color": {
      "white": {
        "value": "#FFFFFF",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "#FFFFFF"
        },
        "name": "WbColorWhite",
        "attributes": {
          "category": "wb",
          "type": "color",
          "item": "white"
        },
        "path": [
          "wb",
          "color",
          "white"
        ]
      },
      "black": {
        "value": "#000000",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "#000000"
        },
        "name": "WbColorBlack",
        "attributes": {
          "category": "wb",
          "type": "color",
          "item": "black"
        },
        "path": [
          "wb",
          "color",
          "black"
        ]
      },
      "red": {
        "10": {
          "value": "#FFF0F0",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#FFF0F0"
          },
          "name": "WbColorRed10",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "10"
          },
          "path": [
            "wb",
            "color",
            "red",
            "10"
          ]
        },
        "20": {
          "value": "#F4BDBF",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#F4BDBF"
          },
          "name": "WbColorRed20",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "20"
          },
          "path": [
            "wb",
            "color",
            "red",
            "20"
          ]
        },
        "30": {
          "value": "#E98A8D",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#E98A8D"
          },
          "name": "WbColorRed30",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "30"
          },
          "path": [
            "wb",
            "color",
            "red",
            "30"
          ]
        },
        "40": {
          "value": "#DE575C",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#DE575C"
          },
          "name": "WbColorRed40",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "40"
          },
          "path": [
            "wb",
            "color",
            "red",
            "40"
          ]
        },
        "50": {
          "value": "#D2232A",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#D2232A"
          },
          "name": "WbColorRed50",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "50"
          },
          "path": [
            "wb",
            "color",
            "red",
            "50"
          ]
        },
        "60": {
          "value": "#B31217",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#B31217"
          },
          "name": "WbColorRed60",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "60"
          },
          "path": [
            "wb",
            "color",
            "red",
            "60"
          ]
        },
        "70": {
          "value": "#930004",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#930004"
          },
          "name": "WbColorRed70",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "70"
          },
          "path": [
            "wb",
            "color",
            "red",
            "70"
          ]
        },
        "80": {
          "value": "#71070A",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#71070A"
          },
          "name": "WbColorRed80",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "80"
          },
          "path": [
            "wb",
            "color",
            "red",
            "80"
          ]
        },
        "90": {
          "value": "#4E0D0F",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#4E0D0F"
          },
          "name": "WbColorRed90",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "red",
            "subitem": "90"
          },
          "path": [
            "wb",
            "color",
            "red",
            "90"
          ]
        }
      },
      "grey": {
        "10": {
          "value": "#EDEAEA",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#EDEAEA"
          },
          "name": "WbColorGrey10",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "10"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "10"
          ]
        },
        "20": {
          "value": "#DDDDDD",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#DDDDDD"
          },
          "name": "WbColorGrey20",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "20"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "20"
          ]
        },
        "30": {
          "value": "#BCBCBC",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#BCBCBC"
          },
          "name": "WbColorGrey30",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "30"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "30"
          ]
        },
        "40": {
          "value": "#9E9E9E",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#9E9E9E"
          },
          "name": "WbColorGrey40",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "40"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "40"
          ]
        },
        "50": {
          "value": "#808080",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#808080"
          },
          "name": "WbColorGrey50",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "50"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "50"
          ]
        },
        "60": {
          "value": "#6C6C6C",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#6C6C6C"
          },
          "name": "WbColorGrey60",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "60"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "60"
          ]
        },
        "70": {
          "value": "#575757",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#575757"
          },
          "name": "WbColorGrey70",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "70"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "70"
          ]
        },
        "80": {
          "value": "#434343",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#434343"
          },
          "name": "WbColorGrey80",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "80"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "80"
          ]
        },
        "90": {
          "value": "#2E2E2E",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "#2E2E2E"
          },
          "name": "WbColorGrey90",
          "attributes": {
            "category": "wb",
            "type": "color",
            "item": "grey",
            "subitem": "90"
          },
          "path": [
            "wb",
            "color",
            "grey",
            "90"
          ]
        }
      }
    },
    "size": {
      "headerHeight": {
        "value": "75px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "75px"
        },
        "name": "WbSizeHeaderHeight",
        "attributes": {
          "category": "wb",
          "type": "size",
          "item": "headerHeight"
        },
        "path": [
          "wb",
          "size",
          "headerHeight"
        ]
      },
      "largeGap": {
        "value": "32px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "WbSizeLargeGap",
        "attributes": {
          "category": "wb",
          "type": "size",
          "item": "largeGap"
        },
        "path": [
          "wb",
          "size",
          "largeGap"
        ]
      },
      "smallGap": {
        "value": "6px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "6px"
        },
        "name": "WbSizeSmallGap",
        "attributes": {
          "category": "wb",
          "type": "size",
          "item": "smallGap"
        },
        "path": [
          "wb",
          "size",
          "smallGap"
        ]
      },
      "horizontalMargin": {
        "mobileOnly": {
          "value": "2rem",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "2rem"
          },
          "name": "WbSizeHorizontalMarginMobileOnly",
          "attributes": {
            "category": "wb",
            "type": "size",
            "item": "horizontalMargin",
            "subitem": "mobileOnly"
          },
          "path": [
            "wb",
            "size",
            "horizontalMargin",
            "mobileOnly"
          ]
        },
        "tabletPortraitUp": {
          "value": "5vw",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "5vw"
          },
          "name": "WbSizeHorizontalMarginTabletPortraitUp",
          "attributes": {
            "category": "wb",
            "type": "size",
            "item": "horizontalMargin",
            "subitem": "tabletPortraitUp"
          },
          "path": [
            "wb",
            "size",
            "horizontalMargin",
            "tabletPortraitUp"
          ]
        },
        "desktopUp": {
          "value": "10vw",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "10vw"
          },
          "name": "WbSizeHorizontalMarginDesktopUp",
          "attributes": {
            "category": "wb",
            "type": "size",
            "item": "horizontalMargin",
            "subitem": "desktopUp"
          },
          "path": [
            "wb",
            "size",
            "horizontalMargin",
            "desktopUp"
          ]
        },
        "desktopLargeUp": {
          "value": "15vw",
          "filePath": "src/tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "15vw"
          },
          "name": "WbSizeHorizontalMarginDesktopLargeUp",
          "attributes": {
            "category": "wb",
            "type": "size",
            "item": "horizontalMargin",
            "subitem": "desktopLargeUp"
          },
          "path": [
            "wb",
            "size",
            "horizontalMargin",
            "desktopLargeUp"
          ]
        }
      }
    },
    "breakpoint": {
      "mobileOnly": {
        "value": "max-width: 599px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "max-width: 599px"
        },
        "name": "WbBreakpointMobileOnly",
        "attributes": {
          "category": "wb",
          "type": "breakpoint",
          "item": "mobileOnly"
        },
        "path": [
          "wb",
          "breakpoint",
          "mobileOnly"
        ]
      },
      "tabletPortraitUp": {
        "value": "min-width: 600px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "min-width: 600px"
        },
        "name": "WbBreakpointTabletPortraitUp",
        "attributes": {
          "category": "wb",
          "type": "breakpoint",
          "item": "tabletPortraitUp"
        },
        "path": [
          "wb",
          "breakpoint",
          "tabletPortraitUp"
        ]
      },
      "tabletPortraitDown": {
        "value": "max-width: 899px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "max-width: 899px"
        },
        "name": "WbBreakpointTabletPortraitDown",
        "attributes": {
          "category": "wb",
          "type": "breakpoint",
          "item": "tabletPortraitDown"
        },
        "path": [
          "wb",
          "breakpoint",
          "tabletPortraitDown"
        ]
      },
      "tabletLandscapeUp": {
        "value": "min-width: 900px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "min-width: 900px"
        },
        "name": "WbBreakpointTabletLandscapeUp",
        "attributes": {
          "category": "wb",
          "type": "breakpoint",
          "item": "tabletLandscapeUp"
        },
        "path": [
          "wb",
          "breakpoint",
          "tabletLandscapeUp"
        ]
      },
      "desktopUp": {
        "value": "min-width: 1200px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "min-width: 1200px"
        },
        "name": "WbBreakpointDesktopUp",
        "attributes": {
          "category": "wb",
          "type": "breakpoint",
          "item": "desktopUp"
        },
        "path": [
          "wb",
          "breakpoint",
          "desktopUp"
        ]
      },
      "desktopLargeUp": {
        "value": "min-width: 1800px",
        "filePath": "src/tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "min-width: 1800px"
        },
        "name": "WbBreakpointDesktopLargeUp",
        "attributes": {
          "category": "wb",
          "type": "breakpoint",
          "item": "desktopLargeUp"
        },
        "path": [
          "wb",
          "breakpoint",
          "desktopLargeUp"
        ]
      }
    }
  }
};
